import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionComponent } from './subscription/subscription.component';
import { PortalComponent } from './portal/portal.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin/payment/sub',
    pathMatch: 'full',
  },
  {
    path: 'sub',
    component: SubscriptionComponent,
  },
  {
    path: 'portal',
    component: PortalComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChargebeeRoutingModule {}
